import React from 'react'

const CardSliderIcon = ({icon, icon1}) => {
    return (
        <>
            <div>
                {icon === 'user' && (
                    <svg
                        width='20'
                        height='20'
                        viewBox='0 0 20 20'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            d='M3 18C5.9 12.3 14.1 12.3 17 18'
                            stroke='#83A3EB'
                            strokeWidth='1.6'
                            strokeLinecap='round'
                        />
                        <path
                            d='M10 11C12.2091 11 14 9.20914 14 7C14 4.79086 12.2091 3 10 3C7.79086 3 6 4.79086 6 7C6 9.20914 7.79086 11 10 11Z'
                            stroke='#83A3EB'
                            strokeWidth='1.6'
                        />
                    </svg>
                )}
                {icon === 'sphera' && (
                    <svg
                        width='20'
                        height='20'
                        viewBox='0 0 20 20'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <circle
                            cx='10'
                            cy='10'
                            r='9.2'
                            stroke='#83A3EB'
                            strokeWidth='1.6'
                        />
                        <path
                            d='M13.2 10C13.2 12.6857 12.7631 15.0803 12.0856 16.774C11.746 17.623 11.3616 18.2564 10.9757 18.6645C10.5914 19.0708 10.2614 19.2 10 19.2C9.73857 19.2 9.40857 19.0708 9.02426 18.6645C8.63836 18.2564 8.25397 17.623 7.91435 16.774C7.2369 15.0803 6.8 12.6857 6.8 10C6.8 7.3143 7.2369 4.91969 7.91435 3.22604C8.25397 2.377 8.63836 1.7436 9.02426 1.33554C9.40857 0.929164 9.73857 0.8 10 0.8C10.2614 0.8 10.5914 0.929164 10.9757 1.33554C11.3616 1.7436 11.746 2.377 12.0856 3.22604C12.7631 4.91969 13.2 7.3143 13.2 10Z'
                            stroke='#83A3EB'
                            strokeWidth='1.6'
                        />
                        <line
                            x1='1'
                            y1='10.2'
                            x2='19'
                            y2='10.2'
                            stroke='#83A3EB'
                            strokeWidth='1.6'
                        />
                    </svg>
                )}
                {icon === 'video' && (
                    <svg
                        width='20'
                        height='20'
                        viewBox='0 0 20 20'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            d='M4.8 16.4755V3.60533C4.8 3.06572 5.3848 2.72903 5.85146 2.99996L17.2916 9.64178C17.7637 9.91588 17.7543 10.6009 17.2748 10.8619L5.83471 17.0903C5.36826 17.3442 4.8 17.0066 4.8 16.4755Z'
                            stroke='#83A3EB'
                            strokeWidth='1.6'
                            strokeLinejoin='bevel'
                        />
                    </svg>
                )}
                {icon === 'gallery' && (
                    <svg
                        width='21'
                        height='20'
                        viewBox='0 0 21 20'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            d='M1.5 15.1059V5C1.5 3.89543 2.39543 3 3.5 3H17.5C18.6046 3 19.5 3.89543 19.5 5V15.1059C19.5 16.2104 18.6046 17.1059 17.5 17.1059H3.5C2.39543 17.1059 1.5 16.2104 1.5 15.1059Z'
                            stroke='#83A3EB'
                            strokeWidth='1.6'
                        />
                        <path
                            d='M1.5 17.1061L8.70908 9.43402C8.79125 9.34657 8.9314 9.35066 9.00833 9.44276L11.9597 12.9763C12.0468 13.0807 12.2105 13.0695 12.2827 12.9543L14.4214 9.5401C14.4998 9.415 14.682 9.415 14.7604 9.5401L19.5 17.1061'
                            stroke='#83A3EB'
                            strokeWidth='1.6'
                        />
                    </svg>
                )}
                {icon === 'burger' && (
                    <svg
                        width='20'
                        height='20'
                        viewBox='0 0 20 20'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            d='M2 16V4C2 2.89543 2.89543 2 4 2H16C17.1046 2 18 2.89543 18 4V16C18 17.1046 17.1046 18 16 18H4C2.89543 18 2 17.1046 2 16Z'
                            stroke='#83A3EB'
                            strokeWidth='1.6'
                        />
                        <path
                            d='M6 7H14'
                            stroke='#83A3EB'
                            strokeWidth='1.6'
                            strokeLinecap='round'
                        />
                        <path
                            d='M6 10H14'
                            stroke='#83A3EB'
                            strokeWidth='1.6'
                            strokeLinecap='round'
                        />
                        <path
                            d='M6 13H14'
                            stroke='#83A3EB'
                            strokeWidth='1.6'
                            strokeLinecap='round'
                        />
                    </svg>
                )}
                {icon1 === 'details' && (
                    <svg
                        width='20'
                        height='20'
                        viewBox='0 0 20 20'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            d='M19.2 10C19.2 15.081 15.081 19.2 10 19.2C4.91898 19.2 0.8 15.081 0.8 10C0.8 4.91898 4.91898 0.8 10 0.8C15.081 0.8 19.2 4.91898 19.2 10Z'
                            stroke='#83A3EB'
                            strokeWidth='1.6'
                            strokeMiterlimit='10'
                        />
                        <path
                            d='M10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7Z'
                            fill='#83A3EB'
                        />
                        <path
                            d='M10 9L10 11.65L10 14.6'
                            stroke='#83A3EB'
                            strokeWidth='1.6'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                    </svg>
                )}
                {icon === 'flask' && (
                    <svg
                        width='20'
                        height='20'
                        viewBox='0 0 20 20'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            d='M12.3784 1.53967V5.31756L17.5056 17.3708C17.7754 18.0904 17.2357 18.9 16.5161 18.9H4.10304C3.29349 18.9 2.7538 18.0904 3.11359 17.3708L8.24073 5.31756V1.53967'
                            stroke='#83A3EB'
                            strokeWidth='1.6'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                        <path
                            d='M6.80151 1H13.9075'
                            stroke='#83A3EB'
                            strokeWidth='1.6'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                        <path
                            d='M6.35181 9.72516H14.2674'
                            stroke='#83A3EB'
                            strokeWidth='1.6'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                    </svg>
                )}
            </div>
        </>
    )
}

export default CardSliderIcon
